export const SERVER_URL = process.env.REACT_APP_API_HTTP_URL
export const WS_SERVER_URL = process.env.REACT_APP_API_WS_URL
export const CLOUDINARY_UPLOAD_URL = process.env.REACT_APP_CLOUDINARY_UPLOAD_URL
export const CLOUDINARY_CATEGORY = process.env.REACT_APP_CLOUDINARY_CATEGORY
export const CLOUDINARY_FOOD = process.env.REACT_APP_CLOUDINARY_FOOD
export const CLOUDINARY_PROFILE = process.env.REACT_APP_CLOUDINARY_PROFILE
export const CLOUDINARY_CAROUSEL = process.env.REACT_APP_CLOUDINARY_CAROUSEL
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY
